import gql from 'graphql-tag';

export const PERMISSION_FRAGMENT = gql`
  fragment PermissionInfo on Permission {
    resource
    create
    read
    update
    delete
    import
    export
  }
`;

export const ROLE_FRAGMENT = gql`
  fragment RoleInfo on Role {
    role
  }
`;
